import React from 'react';
import { StatusLoadingIcon } from '@/components/icons';
import cx from 'classnames';

import './index.scss';

const StatusLoading = (props: { category: string, isMobile?: boolean }) => {

    const baseClassName = 'c-status-loading';

    const wrapperClassName = cx(
        {[`${baseClassName} ${baseClassName}__${props.category}`]: true},
        {[`${baseClassName}__mobile`]: props.isMobile},
    );

    return (
        <div className={wrapperClassName}>
            <StatusLoadingIcon height= {props.isMobile ? '20px' : '40px'} width={props.isMobile ? '20px' : '40px'} />
        </div>
    )
}

export default StatusLoading